module.exports = __webpack_public_path__ + "static/media/sm1.7bade8e6.png";